IntlMessageFormat.__addLocaleData({"locale":"ia","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ia-FR","parentLocale":"ia"});
